import Vue from "vue";
import Vuex from "vuex";
import { app } from "@/store/modules/app";
import Authentication from "@/store/modules/authentication/index.js";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    filterListofuser: null,
    selectedExportComp: "test",
    alert: { show: false, color: "info", message: "" },
    selectedINDRiskParam: null,
    CustomerRouteData: {},
    sessionOut: false,
  },
  getters: {
    getpreviouspageState: (state) => state.filterListofuser,
  },
  mutations: {
    selectedINDRiskParam(state, payload) {
      console.log("pay", payload);
      state.selectedINDRiskParam = payload;
    },
    setPreviousPageState(state, payload) {
      console.log("state", payload);
      state.filterListofuser = payload;
    },
    setcomponentName(state, payload) {
      console.log("state", payload);
      // alert(payload);
      state.selectedExportComp = payload;
    },

    setCustomerRouteData(state, payload) {
      console.log("state", payload);
      state.CustomerRouteData = payload;
    },
    setAlert(state, data) {
      Object.assign(state.alert, { color: "info", show: true }, data);
      state.alert = data;
    },
    setSessionOut(state, data) {
      state.sessionOut = data;
      console.log(" state.sessionOut", state.sessionOut);
    },
  }, // plugins: [createPersistedState()],
  actions: {
    savePreviousPageState({ commit }, payload) {
      commit("setPreviousPageState", payload);
    },
    savecomponentName({ commit }, payload) {
      // alert(payload);
      commit("setcomponentName", payload);
    },
    setCustomerRouteData({ commit }, payload) {
      commit("getCustomerRouteData", payload);
    },
  },
  modules: {
    app,
    AuthenticationService: Authentication,
  },
});
